export default {
    leftPanel: {
        btnImport: 'Import',
        btnAppointments: 'Appointments',
        btnHistory: 'Import History',
        btnAutomations: 'Automations',
        statistics: 'Statistics',
        confirmed: 'Confirmed',
        notConfirmed: 'Not Confirmed',
        canceled: 'Canceled',
    },
    appointmentsList: {
        allTab: 'All',
        appointmentExcluded: 'Exclusion rules of an automation might prevent the system from sending a confirmation for this appointment automatically',
        bulkAction: 'Bulk Action',
        canceledTab: 'Canceled',
        sentStatus: 'Sent status',
        confirmedTab: 'Confirmed',
        contactUnsubscribed: 'Contact is unsubscribed',
        delete: 'Delete',
        deleteModal: {
            header: 'Delete appointments',
            message: 'Are you sure you want to delete the selected appointments?',
        },
        email: 'Email',
        markCanceled: 'Mark as canceled',
        markConfirmed: 'Mark as confirmed',
        markNotConfirmed: 'Mark as not confirmed',
        name: 'Contact',
        noAppointments: 'No appointments yet.',
        wouldYouLikeToAddOne: 'Would you like to add one?',
        notConfirmedTab: 'Not Confirmed',
        notSent: 'Not Sent',
        pageTitle: 'Appointments',
        phone: 'Phone',
        search: 'Search...',
        sendAppointmentUpdatedSmsModal: {
            header: 'Send SMS Notification',
            message: 'Would you like to notify the client that the appointment status has changed via SMS?',
        },
        sendEmailConfirmation: 'Email confirmation',
        sendSmsConfirmation: 'SMS confirmation',
        status: 'Status',
        time: 'Time',
        actions: 'Actions',
    },
    appointmentModal: {
        addTitle: 'New appointment',
        appointmentCreated: 'Appointment created successfully.',
        appointmentUpdated: 'Appointment updated successfully.',
        contact: 'Contact',
        date: 'Date',
        editTitle: 'Edit appointment',
        notes: 'Notes',
        relatedVehicleMake: 'Related Vehicle Make',
        selectDate: 'Select a date...',
        selectTime: 'Select a time...',
        time: 'Time',
    },
    sendConfirmationModal: {
        titleSms: 'Send confirmation by SMS',
        titleEmail: 'Send confirmation by email',
        templateCategory: 'Template Category',
        template: 'Template',
        preview: 'Preview',
        previousBtn: 'Previous Message',
        nextBtn: 'Next Message',
        placeholders: 'Placeholders',
        cancel: 'Cancel',
        sending: 'Appointments\' confirmations are being sent...',
        sendingFailed: 'An error occured while sending appointments\' confirmations',
    },
    importHistory: {
        actions: 'Actions',
        all: 'All',
        completed: 'Completed',
        date: 'Date',
        delete: 'Delete',
        deleteModal: {
            header: 'Delete import',
            message: 'Are you sure you want to delete the selected import?<br>All associated data will be deleted.',
        },
        failed: 'Failed',
        filename: 'Filename',
        noImports: 'No imports yet.',
        notCompleted: 'Not Completed',
        pageTitle: 'Import History',
        search: 'Search...',
        status: 'Status',
        statusCompleted: 'Completed',
        statusFailed: 'Failed',
        statusUncompleted: 'Not Completed',
        type: 'Type',
        types: {
            appointment: 'Appointment',
            campaign: 'Campaign',
            contact: 'Contact',
        },
        user: 'User',
        viewResult: 'View result',
        comingSoon: 'Feature available soon',
    },
    importResult: {
        pageTitle: 'Import result',
        noAppointmentsImported: 'No appointments imported.',
    },
    automationsList: {
        add: 'Add an automation',
        allTab: 'All',
        bulkAction: 'Bulk Action',
        delete: 'Delete',
        deleteModal: {
            header: 'Delete automations',
            message: 'Are you sure you want to delete the selected automations?',
        },
        name: 'Name',
        pageTitle: 'Automations',
        pause: 'Pause',
        paused: 'Paused',
        pausedTab: 'Paused',
        run: 'Run',
        running: 'Running',
        runningTab: 'Running',
        toAddAutomation: 'to add an automation',
    },
    automationModal: {
        title: 'New Automation Task',
        name: 'Name',
        what: 'What',
        when: 'When',
        same: 'Same',
        hour: 'hour | hours',
        day: 'day | days',
        before: 'before',
        whenWillMessageBeSent: 'When will the message be sent?',
        timeHeader: 'Time',
        dayHeader: 'Day',
        whenAutomationActive: 'When is this automation active?',
        successMessage: 'Your automation was created successfully.',
        updateMessage: 'Your automation was updated successfully.',
    },
};
